import React, { useEffect, useState } from 'react';
import Typography from '@mui/material/Typography';
import GridItem from "app/components/Grid/GridItem.js";
import GridContainer from "app/components/Grid/GridContainer.js";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CardContent from "@mui/material/CardContent";
import Card from "@mui/material/Card";
import { getTrackingEventMilestones, getTrackingEventMilestonesColours } from "app/helpers/consolTracking";
import { CargoMode } from "app/types/enums";

export default function SeaBookingSummary(props) {
    const { bookingDetails } = props;

    const handleQuoteReferenceClick = (shipmentId) => {
        if (shipmentId) {
            return window.location.href = '/LeoSeaPortal/quotedetails?shipmentId=' + shipmentId + ''
        }
    };

    const getDeliveryAddress = (addresses) => {
        var delAddress = addresses.find((address) => {
            return address.addressUseCode === 'DEL';
        })
        if (delAddress) {
            return `${delAddress.organisationName}\n 
                    ${delAddress.locality}\n 
                    ${delAddress.countyState}\n 
                    ${delAddress.postcode}\n 
                    ${delAddress.countryName.toUpperCase()}\n`
        }

        return "";
    };

    const getShipperAddress = (addresses) => {
        var delAddress = addresses.find((address) => {
            return address.addressUseCode === 'SHP';
        })
        if (delAddress) {
            return `${delAddress.organisationName}`
        }

        return "";
    };

    const getConsigneeAddress = (addresses) => {
        var delAddress = addresses.find((address) => {
            return address.addressUseCode === 'CNE';
        })
        if (delAddress) {
            return `${delAddress.organisationName}`
        }

        return "";
    };

    return (
        <React.Fragment>
            <GridContainer>
                <GridItem xs={3}>
                    <Typography fontWeight={700}>Europa Reference</Typography>
                    <Typography variant="body2" color="text.secondary">
                        {bookingDetails.shipmentRef}
                    </Typography>
                </GridItem>

                <GridItem xs={3}>
                    <Typography fontWeight={700}>Purchase Order No</Typography>
                    <Typography variant="body2" color="text.secondary">
                        {bookingDetails.purchaseOrderReferenceNo}
                    </Typography>
                </GridItem>

                <GridItem xs={3}>
                    <Typography fontWeight={700}>Shipper</Typography>
                    <Typography variant="body2" color="text.secondary">
                        {getShipperAddress(bookingDetails.addresses)}
                    </Typography>
                </GridItem>

                <GridItem xs={3}>
                    <Typography fontWeight={700}>Consignee</Typography>
                    <Typography variant="body2" color="text.secondary">
                        {getConsigneeAddress(bookingDetails.addresses)}
                    </Typography>
                </GridItem>
            </GridContainer>

            <GridContainer>
                <GridItem xs={3}>
                    <Typography fontWeight={700}>Delivery Address</Typography>
                    <Typography variant="body2" color="text.secondary">
                        {getDeliveryAddress(bookingDetails.addresses)}
                    </Typography>
                </GridItem>

                <GridItem xs={3}>
                    <Typography fontWeight={700}>ETD</Typography>
                    <Typography variant="body2" color="text.secondary">
                        {bookingDetails.livePlan[0].estimatedDepartureDate}
                    </Typography>
                </GridItem>

                <GridItem xs={3}>
                    <Typography fontWeight={700}>ETA</Typography>
                    <Typography variant="body2" color="text.secondary">
                        {bookingDetails.livePlan[0].estimatedArrivalDate}
                    </Typography>
                </GridItem>

                <GridItem xs={3}>
                    <Typography fontWeight={700}>Europa Predicted ETA</Typography>
                    <Typography variant="body2" color="text.secondary">{}
                        {bookingDetails.livePlan[0].europaPredictedArrivalDate}
                    </Typography>
                </GridItem>
            </GridContainer>

            <GridContainer>
                <GridItem xs={3}>
                    <Typography fontWeight={700}>Cargo Mode</Typography>
                    <Typography variant="body2" color="text.secondary">
                        {bookingDetails.cargoMode}
                    </Typography>
                </GridItem>

                <GridItem xs={3}>
                    <Typography fontWeight={700}>Port of Loading</Typography>
                    <Typography variant="body2" color="text.secondary">
                        {bookingDetails.sourceTerminalLabel}
                    </Typography>
                </GridItem>

                <GridItem xs={3}>
                    <Typography fontWeight={700}>Port of Discharge</Typography>
                    <Typography variant="body2" color="text.secondary">
                        {bookingDetails.destinationTerminalLabel}
                    </Typography>
                </GridItem>

                <GridItem xs={3}>
                    <Typography fontWeight={700}>Vessel Name</Typography>
                    <Typography variant="body2" color="text.secondary">
                        {bookingDetails.livePlan[0].vesselName}
                    </Typography>
                </GridItem>

                <GridItem xs={3}>
                    <Typography fontWeight={700}>Term Type</Typography>
                    <Typography variant="body2" color="text.secondary">
                        {bookingDetails.termTypeCode}
                    </Typography>
                </GridItem>


                { bookingDetails.webPortalAssociatedShipment &&
                    <GridItem xs={3}>
                        <Typography fontWeight={700}>Quote Reference</Typography>
                        <Typography onClick={() => handleQuoteReferenceClick(bookingDetails.webPortalAssociatedShipment.shipmentId)} style={{ cursor: 'pointer' }} variant="body2" color="text.secondary">
                            <u>{bookingDetails.webPortalAssociatedShipment.shipmentRef}</u>
                        </Typography>
                    </GridItem>
                }

                {bookingDetails.cargoMode === CargoMode.LCL &&
                    <GridItem xs={3}>
                        <Typography fontWeight={700}>Delivery Date</Typography>
                        <Typography variant="body2" color="text.secondary">
                            {bookingDetails.expectedDeliveryDateTimeWindowStart}
                        </Typography>
                    </GridItem>
                }
            </GridContainer>
            <div style={{ display: 'flex', flexWrap: 'wrap', width: '100%', justifyContent: 'flex-start', alignItems: 'center', margin: 'auto' }} >
                {getTrackingEventMilestones(bookingDetails.consolTrackingPortalEvents).map((consolTrackingEvent, i, { length }) =>
                    <>
                        <Card sx={{ width: "150px", backgroundColor: getTrackingEventMilestonesColours(consolTrackingEvent.codePhrase), marginTop: '10px' }}>
                            <CardContent>
                                <Typography fontWeight={600} sx={{ fontSize: 14 }} color="#FFFFFF" gutterBottom>
                                    {consolTrackingEvent.portName}
                                </Typography>
                                {consolTrackingEvent.delayDescription &&
                                    <Typography sx={{ fontSize: 14 }} color="#FFFFFF" gutterBottom>
                                        {consolTrackingEvent.delayDescription}
                                    </Typography>
                                }
                            </CardContent>
                        </Card>
                        {length - 1 !== i && <ArrowForwardIcon sx={{ fontSize: 'xx-large', color: '#000000' }} />}
                    </>
                )}
            </div>
        </React.Fragment>
    );
}

